import { render, staticRenderFns } from "./SemenTable.vue?vue&type=template&id=37ec7cae&"
import script from "./SemenTable.vue?vue&type=script&lang=js&"
export * from "./SemenTable.vue?vue&type=script&lang=js&"
import style0 from "./SemenTable.vue?vue&type=style&index=0&id=37ec7cae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports